module.exports = __webpack_public_path__ + "img/playModal.55612b5d.svg";